/* global document, window, URLSearchParams */
(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------------

  function escHtml(v) {
    if (v === null || v === undefined) return '';
    return String(v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function fmtDate(iso) {
    if (!iso) return '';
    try {
      return new Intl.DateTimeFormat(document.documentElement.lang || 'es-PE', {
        year: 'numeric', month: 'long', day: 'numeric',
      }).format(new Date(iso));
    } catch { return iso; }
  }

  function fmtDateTime(iso) {
    if (!iso) return '';
    try {
      return new Intl.DateTimeFormat(document.documentElement.lang || 'es-PE', {
        year: 'numeric', month: 'short', day: 'numeric',
        hour: '2-digit', minute: '2-digit',
      }).format(new Date(iso));
    } catch { return iso; }
  }

  // ---------------------------------------------------------------------------
  // Render helpers
  // ---------------------------------------------------------------------------

  var STATE_LABELS = {
    registered:  'Registrado',
    origin:      'En agencia de origen',
    transit:     'En tránsito',
    destination: 'En agencia de destino',
    delivery:    'En reparto',
    delivered:   'Entregado',
    delayed:     'Con demora',
  };

  var CARRIER_NAMES = { olva: 'Olva Courier', shalom: 'Shalom' };

  function renderBadge(step) {
    var label = STATE_LABELS[step] || step;
    var cls   = step === 'delivered' ? 'success' : step === 'delayed' ? 'warning' : 'info';
    return '<div class="tracking-badge tracking-badge--' + cls + '">'
      + '<span class="tracking-badge__dot"></span>'
      + escHtml(label)
      + '</div>';
  }

  function renderSummary(data) {
    var rows = [
      ['Empresa de transportes', CARRIER_NAMES[data.carrier] || data.carrier],
      ['Guía',            data.guideNumber],
      ['Origen',          data.origin],
      ['Destino',         data.destination],
      ['Contenido',       data.content],
      ['Destinatario',    data.recipient],
      ['Tiempo estimado', data.estimatedDelivery],
    ].filter(function (r) { return r[1]; }).map(function (r) {
      return '<div class="tracking-summary__row">'
        + '<span class="tracking-summary__label">' + escHtml(r[0]) + '</span>'
        + '<span class="tracking-summary__value">' + escHtml(r[1]) + '</span>'
        + '</div>';
    }).join('');
    return '<div class="tracking-summary">' + rows + '</div>';
  }

  // Estados donde NO mostramos fecha (la fecha es la misma del registro inicial,
  // no aporta info nueva al cliente)
  var EVENTS_WITHOUT_DATE = { 'Registrado': true };

  function renderEvents(events) {
    if (!Array.isArray(events) || !events.length) return '';
    var items = events.map(function (ev) {
      var hideDate = EVENTS_WITHOUT_DATE[ev.status] === true;
      var dateStr  = hideDate ? '' : (ev.datetime ? fmtDateTime(ev.datetime) : fmtDate(ev.date));
      return '<li class="tracking-event">'
        + '<div class="tracking-event__dot"></div>'
        + '<div class="tracking-event__body">'
        + '<div class="tracking-event__header">'
        + '<span class="tracking-event__status">' + escHtml(ev.status) + '</span>'
        + (ev.location ? '<span class="tracking-event__location">' + escHtml(ev.location) + '</span>' : '')
        + '</div>'
        + (dateStr ? '<time class="tracking-event__date">' + escHtml(dateStr) + '</time>' : '')
        + (ev.description ? '<p class="tracking-event__desc">' + escHtml(ev.description) + '</p>' : '')
        + '</div>'
        + '</li>';
    }).join('');
    return '<div class="tracking-events-section">'
      + '<p class="tracking-events-title">Historial de envío</p>'
      + '<ul class="tracking-events">' + items + '</ul>'
      + '</div>';
  }

  // ---------------------------------------------------------------------------
  // Init
  // ---------------------------------------------------------------------------

  function initSection(configEl) {
    var config;
    try { config = JSON.parse(configEl.textContent); } catch { return; }

    var sid      = config.sectionId;
    var endpoint = config.endpoint;
    var form     = document.getElementById('tracking-form-' + sid);
    var statusEl = document.getElementById('tracking-status-' + sid);
    var resultEl = document.getElementById('tracking-result-' + sid);

    // Olva fields
    var olvaWrap    = document.getElementById('tracking-numero-olva-wrap-' + sid);
    var anioInput   = document.getElementById('tracking-anio-' + sid);
    var numeroInput = document.getElementById('tracking-numero-' + sid);

    // Shalom fields
    var shalomWrap        = document.getElementById('tracking-numero-shalom-wrap-' + sid);
    var numeroShalomInput = document.getElementById('tracking-numero-shalom-' + sid);
    var codigoWrap        = document.getElementById('tracking-codigo-wrap-' + sid);
    var codigoInput       = document.getElementById('tracking-codigo-' + sid);

    if (!form) return;

    // Show/hide fields based on carrier
    function applyCarrier(carrier) {
      var isShalom = carrier === 'shalom';
      if (olvaWrap)   olvaWrap.style.display   = isShalom ? 'none' : '';
      if (shalomWrap) shalomWrap.style.display  = isShalom ? '' : 'none';
      if (codigoWrap) codigoWrap.style.display  = isShalom ? '' : 'none';
      if (codigoInput) codigoInput.required     = isShalom;
      if (numeroShalomInput) numeroShalomInput.required = isShalom;
      if (numeroInput) numeroInput.required = !isShalom;
    }

    form.querySelectorAll('input[name="carrier"]').forEach(function (radio) {
      radio.addEventListener('change', function () { applyCarrier(radio.value); });
    });

    // Advance focus: year field → numero field on "-" or when 2 digits entered
    if (anioInput && numeroInput) {
      anioInput.addEventListener('input', function () {
        if (anioInput.value.replace(/\D/g, '').length >= 2) {
          numeroInput.focus();
        }
      });
      anioInput.addEventListener('keydown', function (e) {
        if (e.key === '-' || e.key === 'Tab') {
          e.preventDefault();
          numeroInput.focus();
        }
      });
    }

    // Prefill from query params: ?carrier=shalom&numero=78133011&codigo=K9HN
    // Para WhatsApp usar %26 en lugar de & : ?carrier=shalom%26numero=78133011%26codigo=K9HN
    var params = new URLSearchParams(window.location.search);
    var prefillCarrier = params.get('carrier');
    var prefillNumero  = params.get('numero');
    var prefillCodigo  = params.get('codigo');

    if (prefillCarrier) {
      var radioToCheck = form.querySelector('input[name="carrier"][value="' + prefillCarrier + '"]');
      if (radioToCheck) {
        radioToCheck.checked = true;
        applyCarrier(prefillCarrier);
      }
    }

    // Prefill valores — siempre después de applyCarrier para que los campos estén visibles
    if (prefillNumero) {
      var isOlvaPrefill = !prefillCarrier || prefillCarrier === 'olva';
      if (isOlvaPrefill) {
        var dashIdx = prefillNumero.indexOf('-');
        if (dashIdx > -1) {
          if (anioInput)   anioInput.value   = prefillNumero.slice(0, dashIdx);
          if (numeroInput) numeroInput.value = prefillNumero.slice(dashIdx + 1);
        } else {
          if (numeroInput) numeroInput.value = prefillNumero;
        }
      } else {
        if (numeroShalomInput) {
          numeroShalomInput.value = prefillNumero;
          numeroShalomInput.dispatchEvent(new Event('input'));
        }
      }
    }
    if (prefillCodigo && codigoInput) {
      codigoInput.value = prefillCodigo;
      codigoInput.dispatchEvent(new Event('input'));
    }

    // Auto-submit solo si todos los campos necesarios están completos
    if (prefillNumero && (prefillCarrier !== 'shalom' || prefillCodigo)) {
      setTimeout(function () {
        form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }, 50);
    }

    // Status helpers
    function showStatus(msg, type) {
      statusEl.hidden = false;
      statusEl.className = 'tracking-status tracking-status--' + (type || 'info');
      statusEl.textContent = msg;
      resultEl.hidden = true;
      resultEl.innerHTML = '';
    }

    function showResult(data) {
      statusEl.hidden = true;
      resultEl.hidden = false;
      resultEl.innerHTML = renderBadge(data.currentStep)
        + renderSummary(data)
        + (data.events && data.events.length ? '<hr class="tracking-divider">' : '')
        + renderEvents(data.events);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd      = new FormData(form);
      var carrier = (fd.get('carrier') || 'olva').toString().trim();

      // Build numero: Olva = "YY-NNNNNN", Shalom = plain number
      var numero, codigo;
      if (carrier === 'olva') {
        var anio   = (anioInput   ? anioInput.value   : '26').replace(/\D/g, '').slice(0, 2) || '26';
        var numRaw = (numeroInput ? numeroInput.value : '').replace(/\D/g, '').trim();
        numero = anio + '-' + numRaw;
      } else {
        numero = (numeroShalomInput ? numeroShalomInput.value : '').trim();
        codigo = (fd.get('codigo') || '').toString().trim();
      }

      if (!numero || numero === '-' || (carrier === 'olva' && numero.endsWith('-'))) {
        showStatus('Ingresa el número de guía.', 'error'); return;
      }
      if (carrier === 'shalom' && !codigo) {
        showStatus('Para Shalom necesitas el código de guía (ej. K9HN).', 'error'); return;
      }

      showStatus('Consultando el estado de tu envío...', 'info');
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;

      var qs = new URLSearchParams({ carrier: carrier, numero: numero });
      if (codigo) qs.set('codigo', codigo);

      // El custom-button del tema usa aria-busy="true" al submit del form para
      // mostrar la animación de los 3 puntos. Hay que removerlo manualmente
      // cuando termina la consulta — disabled=false solo no es suficiente.
      function enableBtn() {
        if (!btn) return;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }

      fetch(endpoint + '?' + qs.toString(), {
        method: 'GET',
        headers: { Accept: 'application/json' },
      })
        .then(function (res) {
          if (res.status === 404) { showStatus('No encontramos esa guía. Verifica el número y el código.', 'error'); enableBtn(); return; }
          if (res.status === 429) { showStatus('Demasiados intentos. Espera un momento.', 'error'); enableBtn(); return; }
          if (res.status === 400) { showStatus('Datos inválidos. Revisa los campos.', 'error'); enableBtn(); return; }
          if (!res.ok)            { showStatus('Error al consultar. Intenta en unos minutos.', 'error'); enableBtn(); return; }
          return res.json().then(function (data) {
            showResult(data);
            enableBtn();
          });
        })
        .catch(function () {
          showStatus('Error de conexión. Verifica tu internet e intenta de nuevo.', 'error');
          enableBtn();
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('script[id^="tracking-config-"]').forEach(initSection);
  });
})();
